export const ACCOUNT_NICKNAME_REGEX = /^[a-zA-Z\d\s]*$/;
